// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"a3e3512c","703":"05f543fb"}[chunkId] + ".chunk.js";
};